import { FilterParams, PaginationParams } from '../domain/filter';
import { useGetCampaignListsQuery } from '../slice/api';
import { useMemo } from 'react';

export const useCampaignList = (
  filterParams: FilterParams,
  paginationParams: PaginationParams
) => {
  const { page, pageSize, sortKey, sortDirection } = paginationParams;

  const { data, isFetching, error } = useGetCampaignListsQuery({
    page: page + 1,
    per_page: pageSize,
    sort_key: sortKey,
    sort_direction: sortDirection,
    search_text: filterParams.searchText,
    campaign_type:
      filterParams.selectedCampaignType === 'all'
        ? undefined
        : filterParams.selectedCampaignType,
    report_type: filterParams.selectedReportType,
    client_ids: filterParams.selectedClient?.id
      ? [filterParams.selectedClient.id]
      : undefined,
    advertiser_ids: filterParams.checkedAdvertisers.map(a => a.id),
    approval_status: filterParams.approvalStatus,
    report_date_from: filterParams.reportDateFrom,
  });

  // FIXME: Including separate entries here is meant to be a temporary workaround for a first LCI 3.0 release.
  // Clean this up after the first release and once handing of partner reports/users is determined.
  const campaignListData = useMemo(() => {
    return {
      rawData: data,
      isFetching,
      error,
      campaignList: data?.data.campaignLists ?? [],
      total: data?.data.total,
    };
  }, [data, isFetching, error]);

  return campaignListData;
};
